import { render, staticRenderFns } from "./GuestWallet.vue?vue&type=template&id=5e873b0b&scoped=true"
import script from "./GuestWallet.vue?vue&type=script&lang=js"
export * from "./GuestWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e873b0b",
  null
  
)

export default component.exports